// extracted by mini-css-extract-plugin
export default {"nav":"Navigation_nav__MsE7Z","list":"Navigation_list__hY2hZ","header":"Navigation_header__k5NQZ","footer":"Navigation_footer__l-o4g"};